import { ProcurementTypeItemFragment } from 'generated/resources/graphql'

import { Form, SectionElement } from 'modules/forms'
import { Element } from 'modules/forms/lib/Element'

function returnOrGenerateId(id?: string): string {
  return id || Math.random().toString()
}

function elementToFragment(element: Element, formId: string, sectionId?: string) {
  return {
    ...element,
    id: returnOrGenerateId(element.id),
    description: element.description || '',
    formId,
    sectionId: sectionId || element.sectionId || '',
    type: element.getType(),
    createdAt: element.createdAt || new Date().toISOString(),
    updatedAt: element.updatedAt || new Date().toISOString(),
    options: element.options.map((option) => ({
      ...option,
      id: returnOrGenerateId(option.id),
    })),
    params: element.params || {},
  }
}

function flattenElements(elements: Element[], formId: string) {
  return elements.flatMap((element) => {
    const fragment = elementToFragment(element, formId)
    const flattenedElements = [fragment]

    if (element instanceof SectionElement) {
      const children = element.elements.map((child) =>
        elementToFragment(child, formId, fragment.id)
      )
      flattenedElements.push(...children)
    }

    return flattenedElements
  })
}

export function generatePreview(
  requestType: ProcurementTypeItemFragment,
  form: Form
): ProcurementTypeItemFragment {
  const formId = returnOrGenerateId(form.id)

  return {
    ...requestType,
    formsConnection: {
      nodes: [
        {
          status: 'draft' as const,
          formType: 'custom' as const,
          resourceType: 'Procurement::Type' as const,
          id: formId,
          anonymous: false,
          description: form.description || '',
          resourceId: form.resourceId || '',
          title: form.title,
          elements: flattenElements(form.elements, formId),
        },
      ],
    },
  }
}
